import {DetailedHTMLProps, HTMLAttributes, ReactElement} from "react"
import HorizontalSpacing from "../horizontal-spacing"

interface Props extends DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
    leftCol: ReactElement | ReactElement[],
    rightCol: ReactElement | ReactElement[]
}

const TwoColsWrap = (props: Props) => {
    const {leftCol, rightCol, className, ...rest} = props
    return <div className={className}>
        <HorizontalSpacing>
            <div className="laptop:grid laptop:grid-cols-2 laptop:gap-6" {...rest}>
                <div className="desktop:mx-24">
                    {leftCol}
                </div>
                <div className="desktop:mx-24">
                    {rightCol}
                </div>
            </div>
        </HorizontalSpacing>
    </div>
}

export default TwoColsWrap